import styled from "@emotion/styled"
import { LoadingButton } from "@mui/lab"
import { Breadcrumbs, Typography } from "@mui/material"
import { Link, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import InternError from "../../../components/InternError"
import Loader from "../../../components/Loader"
import {
  useGetPartnerRequestInfosQuery,
  usePendingPartnerRequestMutation,
  useTraitedPartnerRequestMutation,
} from "../../../features/partnerRequestSlice"
import Diagnostic from "../../../models/Diagnostic"
import PartnerRequest, {
  getStatusTypeLabel,
  StatusType,
} from "../../../models/partnerRequest"
import { ResponseApiException } from "../../../models/responseApiType"
import colors from "../../../style/colors"
import GlobalBgStyle from "../../../style/GlobalBgStyle"
import { formatStrToDate, getMessageFromType } from "../../../utils/utils"
import fleche from "../../../assets/right-arrow.png"

const StyledDiv = styled.div`
  h1 {
    font-size: 1.4rem;
    text-align: center;
  }

  @media all and (min-width: 768px) {
    h1 {
      font-size: 1.7rem;
    }
  }

  h2 {
    color: ${colors.blue};
  }

  h3 {
    font-size: 1.3rem;
    font-weight: bolder;
    color: ${colors.blue};
    text-decoration: underline;
  }
`

const StyledSpan = styled.span`
  font-weight: bold;
`

const NoneSpan = styled.span`
  color: darkgrey;
  font-style: italic;
`

const DiagSpan = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  width: 100%;
  margin: 5px 0;
`

function DiagRequestDetail() {
  let { id } = useParams()

  const [TraitedPub, { isLoading: isTraitedLoading }] =
    useTraitedPartnerRequestMutation()
  const [PendingPub, { isLoading: isPendingLoading }] =
    usePendingPartnerRequestMutation()

  const Traitedpub = () => {
    console.log(partReq.id)
    TraitedPub(partReq?.id)
      .unwrap()
      .then(() => {
        toast.success("La demande de diagnostic a été traitée")
      })
      .catch((error: ResponseApiException) => {
        let msg = getMessageFromType(error)
        toast.error(msg)
      })
  }
  const Pendingpub = () => {
    console.log(partReq.id)
    PendingPub(partReq?.id)
      .unwrap()
      .then(() => {
        toast.success("La demande de diagnostic est en cours de traitement")
      })
      .catch((error: ResponseApiException) => {
        let msg = getMessageFromType(error)
        toast.error(msg)
      })
  }

  const {
    data: partReq,
    isSuccess,
    isError,
    isLoading,
  }: {
    data: PartnerRequest
    isSuccess: boolean
    isError: boolean
    isLoading: boolean
  } = useGetPartnerRequestInfosQuery(id)

  let content

  if (isLoading) {
    content = <Loader />
  } else if (isSuccess) {
    content = (
      <>
        <h2 className="text-center mb-4">{partReq?.email}</h2>
        <div className="shadow bg-white p-2 p-sm-4">
          <h3>Informations</h3>
          <div className="my-4">
            <div>
              <StyledSpan>Adresse Postal : </StyledSpan>
              {partReq.postalCode}, {partReq.city}
            </div>
            <div>
              <StyledSpan>Adresse Email : </StyledSpan>
              {partReq.email}
            </div>
            <div>
              <StyledSpan>Numéro : </StyledSpan>
              {partReq.number}
            </div>
            <div>
              <StyledSpan>Numéro de Téléphone : </StyledSpan>
              {partReq.phone}
            </div>
            <div>
              <StyledSpan>Demande effectuée le : </StyledSpan>{" "}
              {formatStrToDate(partReq.createdAt, "dd/MM/yyyy")}
            </div>
          </div>
          <h3>Demande de renseignements</h3>
          <div className="my-4 flex flex-col flex-wrap justify-between">
            <div className="flex flex-row space-x-2">
              <StyledSpan>Status :</StyledSpan>
              {partReq.status === "ToHandle" ? (
                <p className="bg-[#777777] text-white rounded-full px-2">
                  {getStatusTypeLabel(StatusType.TO_HANDLE)}
                </p>
              ) : partReq.status === "Traited" ? (
                <p className="bg-[#007700] text-white rounded-full px-2">
                  {getStatusTypeLabel(StatusType.TRAITED)}
                </p>
              ) : (
                <p className="bg-[#dfe608] rounded-full px-2">
                  {getStatusTypeLabel(StatusType.PENDING)}
                </p>
              )}
            </div>
          </div>
          <h3>Vérifications à faire</h3>
          <div className="my-4 flex flex-col flex-wrap justify-between">
            {partReq.diagnostics?.map((diag: Diagnostic) => (
              <div className="flex flex-row space-x-2">
                <DiagSpan>
                  <img
                    src={fleche}
                    alt="Fleche droite"
                    className="w-[2%] mr-3"
                  />{" "}
                  {diag.name}
                </DiagSpan>
              </div>
            ))}
            <div className="flex lg:flex-row flex-col text-center justify-center">
              {" "}
              {partReq.status === "ToHandle" ? (
                <div className="flex flex-col items-center">
                  <p>
                    Cette demande est-elle traitée ou en cours de traitement ?
                  </p>
                  <div className="flex flex-row space-x-8">
                    <LoadingButton
                      type="submit"
                      loading={isTraitedLoading}
                      disabled={isTraitedLoading}
                      onClick={Traitedpub}
                      className="text-green-800 border-2 rounded px-2 py-1 border-green-800"
                    >
                      Traitée
                    </LoadingButton>
                    <LoadingButton
                      type="submit"
                      loading={isPendingLoading}
                      disabled={isPendingLoading}
                      onClick={Pendingpub}
                      className="text-[#dfe608] border-2 rounded px-2 py-1 border-[#dfe608]"
                    >
                      En cours de traitement
                    </LoadingButton>
                  </div>
                </div>
              ) : partReq.status === "Pending" ? (
                <div className="flex flex-col items-center">
                  <p>Cette demande à été traitée ?</p>
                  <div className="flex flex-row space-x-8">
                    <LoadingButton
                      type="submit"
                      loading={isTraitedLoading}
                      disabled={isTraitedLoading}
                      onClick={Traitedpub}
                      className="text-green-800 border-2 rounded px-2 py-1 border-green-800"
                    >
                      Traitée
                    </LoadingButton>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-center">
                  <NoneSpan>Demande déjà traitée.</NoneSpan>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    )
  } else if (isError) {
    content = <InternError />
  }
  return (
    <StyledDiv className="container">
      <GlobalBgStyle />
      <Breadcrumbs>
        <Link to="/admin/diagRequest" style={{ color: colors.darkBlue }}>
          Diagnostics
        </Link>
        <Typography color="text.primary">Fiche détaillée</Typography>
      </Breadcrumbs>
      <h1>Fiche détaillée</h1>
      {content}
    </StyledDiv>
  )
}

export default DiagRequestDetail
